import React from 'react';

import { MoreOutlined } from '@ant-design/icons';
import { Badge, Checkbox, Dropdown, theme, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { ProcessStageStatusSchema } from '@app/models/orders';

import { CheckboxGroup } from '@components/TableEditMenu/styles';

import { usePatchOrderProcessModuleQuery } from '../../hooks';

interface IProps {
  statuses: ProcessStageStatusSchema[];
  hiddenStatusUids?: string[];
  moduleUid: string;
  processUid: string;
}

export const StageStatusesMenu: React.FC<IProps> = ({ statuses, hiddenStatusUids = [], moduleUid, processUid }) => {
  const { mutate } = usePatchOrderProcessModuleQuery();

  const { token } = theme.useToken();
  const ordersT = useTranslation(NSKeys.orders);
  const statusUids = statuses.map((status) => status.uid);
  const visibleStatusUids = statuses
    .filter((status) => !hiddenStatusUids.includes(status.uid))
    .map((status) => status.uid);

  const handleChange = (checkedValues: any[]) => {
    if (checkedValues.length === 0) {
      return;
    }

    const nextHiddenStatusUids = statusUids.filter((uid) => !checkedValues.includes(uid));

    mutate({
      hiddenStatusUids: nextHiddenStatusUids,
      moduleUid,
      processUid,
    });
  };

  return (
    <Dropdown
      trigger={['click']}
      placement="bottomLeft"
      popupRender={() => (
        <div
          style={{
            backgroundColor: token.colorBgElevated,
            borderRadius: token.borderRadiusLG,
            boxShadow: token.boxShadowSecondary,
          }}>
          <CheckboxGroup defaultValue={visibleStatusUids} onChange={handleChange}>
            {statuses.map((status) => (
              <Checkbox
                disabled={visibleStatusUids.length === 1 && visibleStatusUids[0] === status.uid}
                value={status.uid}
                key={status.uid}>
                {status.name}
              </Checkbox>
            ))}
          </CheckboxGroup>
        </div>
      )}>
      <Tooltip title={ordersT.t('columnsVisibilityTooltip')}>
        <Badge dot={hiddenStatusUids.length > 0} color={token.colorPrimary}>
          <MoreOutlined style={{ cursor: 'pointer' }} />
        </Badge>
      </Tooltip>
    </Dropdown>
  );
};
